import { render, staticRenderFns } from "./IconTicketSolid.vue?vue&type=template&id=67ede331"
import script from "./IconTicketSolid.vue?vue&type=script&lang=js"
export * from "./IconTicketSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports